module.exports = {
      id: "icon-play-usage",
      viewBox: "0 0 17.037 21.916",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#icon-play",
      toString: function () {
        return this.url;
      }
    }